<div class="flex flex-wrap">
  <div *ngFor="let grid of grids$ | async" (click)="selectGrid(grid.id)" class="w-64 mx-2 my-4 flex flex-col flex-wrap justify-center items-center transition ease-in-out duration-300 cursor-pointer border-2 border-transparent hover:border-blue-300 hover:shadow-lg">
    <img [src]="grid.image" alt=""/>
    <p class="m-2">{{ descriptionType === 'letter' ? grid.descriptionLetters : grid.descriptionStempel }}</p>
    <app-button name="Selecteer werkblad" classes="my-2"></app-button>
  </div>
</div>
